<template>
    <div class="withdrawal-record" id="withdrawaltitle">
      <div class="lowerview">
        <div class="centerview">
          <el-row>
            <el-col :span="21">
              <ul class="search-form">
                <li class="search-inputs-row">
                  <div class="input-group">
                    <el-input
                      placeholder="提现单号"
                      v-model="withdrawal_id_input"
                      clearable
                      style="width: 200px; margin-right: 10px;"
                    ></el-input>
                    <el-input
                      placeholder="用户手机号"
                      v-model="phone_input"
                      clearable
                      style="width: 200px;"
                    ></el-input>
                  </div>
                </li>
                
                <li>
                  <el-select
                    v-model="status_input"
                    clearable
                    style="width: 140px"
                    placeholder="提现状态"
                  >
                    <el-option
                      v-for="(value, key) in statusMap"
                      :key="key"
                      :label="value"
                      :value="key"
                    ></el-option>
                  </el-select>
                </li>
                
                <li>
                  <el-date-picker
                    v-model="starttime_value"
                    type="datetime"
                    style="width: 200px"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    placeholder="开始时间"
                  ></el-date-picker>
                </li>
                <li>
                  <el-date-picker
                    v-model="endtime_value"
                    type="datetime"
                    placeholder="结束时间"
                    style="width: 200px"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    :picker-options="pickerOptions"
                  ></el-date-picker>
                </li>
              </ul>
            </el-col>
            <el-col :span="3">
              <ul class="action-buttons">
                <!-- 钱包资金可用余额显示 -->
                <li class="fund-pool-item" style="margin-bottom: 0;">
                  <el-button
                    type="info"
                    class="fund-pool-button"
                    @click="showFundPoolDialog = true"
                    style="width: 100%; height: 40px;"
                  >
                    <span class="button-content">
                      <span class="button-text">钱包资金</span>
                      <span class="balance-amount">¥{{ formatFundPool(fundPool) }}</span>
                    </span>
                  </el-button>
                </li>
                <li>
                  <el-button
                    type="primary"
                    class="querybutton search"
                    @click="querybtnClick()"
                    style="width: 100%; height: 40px;"
                    >查询</el-button
                  >
                </li>
                <!-- <li>
                  <el-button
                    type="success"
                    class="exportbutton"
                    @click="exportbtnClick()"
                    :disabled="exportPrivilege == 1"
                    >导出</el-button
                  >
                </li> -->
              </ul>
            </el-col>
          </el-row>
        </div>
      <div class="bottomviewtwo">
          <el-table
            :data="tableData"
            :header-cell-style="{ background: '#f3f3f3', color: '#333333' }"
            :summary-method="getSummaries"
            show-summary
            style="width: 100%"
          >
            <el-table-column
              align="left"
              prop="phone_number"
              label="手机号"
              :show-overflow-tooltip="true"
            ></el-table-column>
            <el-table-column
              align="left"
              prop="withdrawal_id"
              label="提现单号"
              :show-overflow-tooltip="true"
              width="180"
            ></el-table-column>
            <el-table-column
              align="left"
              prop="amount"
              label="提现金额"
              :formatter="formatAmount"
            ></el-table-column>
            <el-table-column
              align="left"
              prop="status"
              label="提现状态"
              :formatter="formatStatus"
            ></el-table-column>
            <el-table-column
              align="left"
              prop="apply_time"
              label="申请时间"
              :show-overflow-tooltip="true"
              width="180"
            ></el-table-column>
            <el-table-column
              align="left"
              prop="complete_time"
              label="完成时间"
              :show-overflow-tooltip="true"
              width="180"
            ></el-table-column>
            <!-- <el-table-column
              align="left"
prop="bank_name"
              label="银行名称"
              :show-overflow-tooltip="true"
            ></el-table-column>
            <el-table-column
              align="left"
              prop="bank_account"
              label="银行账号"
              :show-overflow-tooltip="true"
              width="180"
            ></el-table-column> -->
            <el-table-column
              align="left"
              prop="remark"
              label="备注"
              :show-overflow-tooltip="true"
            ></el-table-column>
  
            <el-table-column label="操作" width="180">
              <template slot-scope="scope">
                <!-- 根据后端返回的状态码0（待审核）调整审核按钮条件 -->
                <div v-if="scope.row.status == 0" class="audit-buttons">
                  <el-button
                    type="primary"
                    size="mini"
                    @click="handleWithdrawal(scope.row.withdrawal_id, 'approve')"
                  >审核通过</el-button>
                  <el-button
                    type="danger"
                    size="mini"
                    @click="handleWithdrawal(scope.row.withdrawal_id, 'reject')"
                  >审核拒绝</el-button>
                </div>
                <!-- 状态为审核拒绝（状态码3）时显示再次审核按钮 -->
                <div v-else-if="scope.row.status == 3" class="reaudit-button">
                  <el-button
                    type="warning"
                    size="mini"
                    @click="handleReaudit(scope.row.withdrawal_id)"
                  >再次审核</el-button>
                </div>
                <span v-else>--</span>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="cutpagesview">
          <el-pagination
            class="pageinclass"
            background
            :page-size="pagesize"
            :page-count="pagecount"
            :current-page="currentPage"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            layout="prev, pager, next,jumper"
            :total="total"
          ></el-pagination>
        </div>

        <!-- 钱包资金余额对话框 -->
        <el-dialog
          title="钱包资金可用余额"
          :visible.sync="showFundPoolDialog"
          width="520px"
          center
          :close-on-click-modal="false"
          class="fund-pool-dialog"
        >
          <div class="fund-pool-dialog-content">
            <div class="fund-pool-info">
              <div class="info-section">
                <h4 class="section-title">统计方式</h4>
                <div class="custom-radio-group">
                  <label class="custom-radio-label">
                    <input 
                      type="radio" 
                      v-model="fundPoolType" 
                      value="default"
                      class="custom-radio-input"
                    >
                    <span class="custom-radio-checkmark"></span>
                    <span class="custom-radio-text">默认统计</span>
                  </label>
                  <label class="custom-radio-label">
                    <input 
                      type="radio" 
                      v-model="fundPoolType" 
                      value="custom"
                      class="custom-radio-input"
                    >
                    <span class="custom-radio-checkmark"></span>
                    <span class="custom-radio-text">自定义时间</span>
                  </label>
                </div>
              </div>
              
              <div v-if="fundPoolType === 'custom'" class="info-section time-section">
                <h4 class="section-title">查询时间范围</h4>
                <div class="time-display">
                  <span class="time-label">开始时间：</span>
                  <span class="time-value">{{ starttime_value || '未选择' }}</span>
                </div>
                <div class="time-display">
                  <span class="time-label">结束时间：</span>
                  <span class="time-value">{{ endtime_value || '未选择' }}</span>
                </div>
              </div>
              
              <div class="info-section balance-section">
                <h4 class="section-title">资金信息</h4>
                <div class="balance-display">
                  <div class="balance-item">
                    <span class="balance-label">可用余额：</span>
                    <span class="balance-amount large">¥{{ formatFundPool(fundPool) }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          
          <span slot="footer" class="dialog-footer">
            <el-button 
              @click="showFundPoolDialog = false" 
              size="medium"
              class="dialog-button"
            >关 闭</el-button>
          </span>
        </el-dialog>

        
        <!-- 审核对话框 -->
        <el-dialog
          :title="dialogTitle"
          :visible.sync="auditDialogVisible"
          width="450px"
          center
          :close-on-click-modal="false"
          :before-close="handleDialogClose"
        >
          <div class="audit-dialog-content">
            <div class="audit-info">
              <div class="info-item">
                <span class="label">提现单号：</span>
                <span class="value">{{ currentWithdrawalData ? currentWithdrawalData.withdrawal_id : '' }}</span>
              </div>
              <div class="info-item">
                <span class="label">提现金额：</span>
                <span class="value">¥{{ currentWithdrawalData ? currentWithdrawalData.amount : '0.00' }}</span>
              </div>
              <div class="info-item">
                <span class="label">申请人：</span>
                <span class="value">{{ currentWithdrawalData ? currentWithdrawalData.phone_number : '' }}</span>
              </div>
            </div>
            
            <!-- 再次审核时的提示信息 -->
            <div v-if="auditAction === 'reaudit'" class="reaudit-notice">
              <el-alert
                title="再次审核提示"
                type="info"
                description="此提现申请之前已被拒绝，现在将重新提交审核。"
                show-icon
                :closable="false"
              ></el-alert>
            </div>
            
            <!-- 再次审核时显示修改金额选项 -->
            <div v-if="auditAction === 'reaudit'" class="amount-modify-section">
              <div class="section-title">修改提现金额（可选）</div>
              <div class="amount-input-group">
                <el-input-number
                  v-model="modifiedAmount"
                  :min="0.01"
                  :max="999999.99"
                  :precision="2"
                  :step="1"
                  placeholder="请输入修改后的金额"
                  controls-position="right"
                  style="width: 100%;"
                  :disabled="!enableAmountModify"
                ></el-input-number>
                <div class="amount-actions">
                  <!-- 使用自定义样式替代原生复选框 -->
                  <div class="custom-checkbox-wrapper">
                    <input 
                      type="checkbox" 
                      :id="'amount-modify-' + currentWithdrawalData?.id"
                      v-model="enableAmountModify"
                      class="custom-checkbox"
                    />
                    <label :for="'amount-modify-' + currentWithdrawalData?.id" class="custom-checkbox-label">
                      <span class="custom-checkbox-icon"></span>
                      修改金额
                    </label>
                  </div>
                  <el-button 
                    type="text" 
                    size="mini" 
                    @click="resetAmount"
                    :disabled="!enableAmountModify"
                    class="reset-button"
                  >
                    重置为原金额
                  </el-button>
                </div>
              </div>
              <div v-if="enableAmountModify" class="amount-difference">
                <span class="difference-label">金额变化：</span>
                <span :class="['difference-value', amountDifference >= 0 ? 'positive' : 'negative']">
                  {{ amountDifference >= 0 ? '+' : '' }}{{ amountDifference.toFixed(2) }}
                </span>
              </div>
            </div>
            
            <div class="audit-reason" v-if="auditAction === 'reject' || auditAction === 'reaudit'">
              <el-input
                type="textarea"
                :rows="3"
                :placeholder="auditAction === 'reaudit' ? '请输入审核备注（可选）' : '请输入拒绝原因'"
                v-model="rejectReason"
                maxlength="200"
                show-word-limit
              ></el-input>
            </div>
            
            <!-- 加载过渡画面 -->
            <div v-if="auditLoading" class="audit-loading">
              <el-icon class="is-loading">
                <Loading />
              </el-icon>
              <span class="loading-text">正在处理中，请稍候...</span>
            </div>
          </div>
          
          <span slot="footer" class="dialog-footer">
            <el-button 
              @click="handleCancel" 
              size="small"
              :disabled="auditLoading"
            >取 消</el-button>
            <el-button 
              type="primary" 
              @click="handleAuditConfirm()"
              :disabled="(auditAction === 'reject' && !rejectReason) || auditLoading"
              :loading="auditLoading"
              size="small"
            >
              {{ auditAction === 'reaudit' ? '重新提交' : '确 定' }}
            </el-button>
          </span>
        </el-dialog>
      </div>
    </div>
</template>
  
  <script>
  import { transformStringTime } from "../../filters/index.js";
  import API_ROOT from "../../../config/dev.env";
  
  export default {
    name: "WithdrawalRecordData",
    data() {
      return {
        total: 0,
        pagesize: 10,
        currentPage: 1,
        pagecount: 1,
        statistics: [],
        starttime_value: "",
        endtime_value: "",
        withdrawal_id_input: "",
        phone_input: "",
        status_input: "",
        
        
        // withdrawal_type: "",
        // withdrawalTypeList: [
        //   { value: "wallet", label: "钱包提现" },
        //   { value: "income", label: "收益提现" }
        // ],
        
        tableData: [],
        pickerOptions: {
          disabledDate: (time) => {
            return (
              time.getTime() < this.start_date || time.getTime() > Date.now()
            );
          },
        },
        exportPrivilege: 1,
        
        // 状态映射
        statusMap: {
          0: '待审核',
          1: '提现成功',
          2: '审核通过,提现中',
          3: '审核拒绝'
        },
        
        // 钱包资金
        fundPool: 0,                    // 钱包资金可用余额
        showFundPoolDialog: false,      // 显示资金余额对话框
        fundPoolType: 'default',        // 资金统计类型：default-默认统计，custom-自定义时间


        // 审核相关
        auditDialogVisible: false,
        currentWithdrawalData: null,
        auditAction: '',
        rejectReason: '',
        dialogTitle: '',
        auditLoading: false,  // 审核加载状态
        
        // 金额修改相关
        enableAmountModify: false,    // 是否启用金额修改
        modifiedAmount: 0,           // 修改后的金额
        originalAmount: 0,           // 原始金额
        
        // 异步处理相关状态
        asyncProcessing: false,      // 是否异步处理中
        currentTaskId: null,         // 当前任务ID
        pollingInterval: null,       // 轮询定时器
        pollingCount: 0,             // 轮询次数
        maxPollingCount: 30,         // 最大轮询次数（约3分钟）
        pollingDelay: 3000           // 轮询间隔（3秒）
      };
    },
    
    beforeRouteEnter(to, from, next) {
      window.document.body.style.backgroundColor = "#efefef";
next();
    },
beforeRouteLeave(to, from, next) {
      window.document.body.style.backgroundColor = "#001928";
      next();
    },
  
    mounted() {
      this.checkExportPrivilege();
      this.$nextTick(function () {
        this.defaultTime();
this.querybtnClick();
      });
    },

    computed: {
      // 计算金额差异
      amountDifference() {
        if (!this.enableAmountModify || !this.originalAmount) return 0;
        return parseFloat(this.modifiedAmount) - parseFloat(this.originalAmount);
      }
    },  

  methods: {
checkExportPrivilege() {
      let role = this.$store.state.role || [];
      for (let i in role) {
        if (role[i].view_name == "经营分析") {
          for (let j in role[i].chlid) {
            if (role[i].chlid[j].view_name == "提现记录") {
              for (let m in role[i].chlid[j].method) {
                if (role[i].chlid[j].method[m].method_name == "导出提现记录") {
                  this.exportPrivilege = 0;
                }
              }
            }
          }
        }
      }
    },

    defaultTime() {
      var d = new Date();
      let start_date = d.getFullYear() + "-" + 
        this.checkTime(d.getMonth() + 1) + "-" + 
        this.checkTime(d.getDate()) + " 00:00:00";
      this.starttime_value = start_date;
      this.start_date = start_date;

      var d1 = new Date();
      let end_date = d1.getFullYear() + "-" + 
        this.checkTime(d1.getMonth() + 1) + "-" + 
        this.checkTime(d1.getDate()) + " " + 
        this.checkTime(d1.getHours()) + ":" + 
        this.checkTime(d1.getMinutes()) + ":" + 
        this.checkTime(d1.getSeconds());
      this.endtime_value = end_date;
    },

    checkTime(i) {
      if (i < 10) {
        i = "0" + i;
      }
      return i;
    },

    handleSizeChange(val) {},
    
    handleCurrentChange(val) {
this.currentPage = val;
      this.querybtnClick(String(val));
    },

querybtnClick(page) {
      this.tableData = [];
      let params = {
        uid: localStorage.getItem("uid"),
        token: localStorage.getItem("token"),
        fundPoolType: this.fundPoolType,
        action: "getWithdrawalRecord"
      };
if (page) params.page = page;

      // if (this.withdrawal_type) params.withdrawal_type = this.withdrawal_type;
      if (this.status_input) params.status = this.status_input;
      if (this.withdrawal_id_input) params.withdrawal_id = this.withdrawal_id_input;
if (this.phone_input) params.phone_number = this.phone_input;
      
      if (this.starttime_value && this.endtime_value) {
        if (this.starttime_value > this.endtime_value) {
          this.$message.warning("结束日期时间不能小于开始日期时间");
          return;
        }
        params.start_time = this.starttime_value;
        params.end_time = this.endtime_value;
      }

      this.$api({
        method: "post",
        url: "/api.php/paymentRecord/index",
        data: params,
        transformRequest: [(data) => {
          let ret = "";
          for (let it in data) {
            ret += encodeURIComponent(it) + "=" + encodeURIComponent(data[it]) + "&";
          }
          return ret;
        }],
      })
      .then((su) => {
        if (su.data.code == 1) {
          this.tableData = su.data.data || [];
          this.statistics = su.data;
          
          // 更新钱包资金可用余额
          if (su.data.fund_pool !== undefined) {
            this.fundPool = su.data.fund_pool;
}
          
          if (!page) {
            this.currentPage = 1;
            this.total = parseInt(su.data._count || 0);
            this.pagecount = su.data.page_count || 1;
          }
        } else if (su.data.code == 300) {
          this.handleSessionExpired(su.data.message);
        } else if (su.data.code == 304) {
          this.tableData = [];
          this.total = 0;
          this.pagecount = 1;
          if (su.data.fund_pool !== undefined) {
            this.fundPool = su.data.fund_pool;
          }
          this.$message.warning("未查询到提现记录");
        } else {
          this.$message.warning(su.data.message || "查询失败");
        }
      })
      .catch((err) => {
        console.error("查询提现记录错误:", err);
        this.$message.error("网络错误，请稍后重试");
      });
    },

    // 格式化资金余额
    formatFundPool(amount) {
      return amount ? parseFloat(amount).toFixed(2) : '0.00';
    },


    formatAmount(row, column, cellValue) {
      return cellValue ? '¥' + parseFloat(cellValue).toFixed(2) : '¥0.00';
    },

    formatStatus(row, column, cellValue) {
      return this.statusMap[cellValue] || '未知状态';
    },
getSummaries(param) {
      const { columns } = param;
      const sums = [];
      const backendData = this.statistics;

      columns.forEach((col, index) => {
        if (index === 0) {
          sums[index] = '总合计';
          return;
        }

        if (col.property === 'amount') {
          const totalAmount = backendData.amount || 0;
          sums[index] = '¥' + parseFloat(totalAmount).toFixed(2);
        } else {
          sums[index] = '';
        }
      });

      return sums;
    },

    handleWithdrawal(withdrawalId, action) {
      this.currentWithdrawalData = this.tableData.find(item => item.withdrawal_id === withdrawalId);
      this.auditAction = action;
      this.rejectReason = '';
      this.dialogTitle = action === 'approve' ? '审核通过' : '审核拒绝';
      this.auditDialogVisible = true;
    },
    
      // 重置金额为原始金额
      resetAmount() {
        this.modifiedAmount = parseFloat(this.originalAmount);
      },
      
      // 处理再次审核
      handleReaudit(withdrawalId) {
        this.currentWithdrawalData = this.tableData.find(item => item.withdrawal_id === withdrawalId);
        this.auditAction = 'reaudit';
        this.rejectReason = '';
        this.dialogTitle = '再次审核提现申请';
        this.auditLoading = false;
        
        // 初始化金额修改相关状态
        this.originalAmount = parseFloat(this.currentWithdrawalData.amount);
        this.modifiedAmount = this.originalAmount;
        this.enableAmountModify = false;
        
        this.auditDialogVisible = true;
      },
      
      // 处理审核确认
      handleAuditConfirm() {
        if (this.auditAction === 'reject' && !this.rejectReason) {
          this.$message.warning('请输入拒绝原因');
          return;
        }
    
        this.auditLoading = true;
        
        let params = {
          uid: localStorage.getItem("uid"),
          token: localStorage.getItem("token"),
          withdrawal_id: this.currentWithdrawalData.withdrawal_id,
          action: this.auditAction
        };
    
        // 根据不同的审核动作设置参数
        if (this.auditAction === 'reject' || this.auditAction === 'reaudit') {
          params.remark = this.rejectReason || '';
        }
    
        // 如果是再次审核且启用了金额修改，添加修改后的金额
        if (this.auditAction === 'reaudit' && this.enableAmountModify) {
          params.modified_amount = this.modifiedAmount.toFixed(2);
        }
    
        this.$api({
          method: "post",
          url: "/api.php/paymentRecord/index",
          data: params,
          transformRequest: [(data) => {
            let ret = "";
            for (let it in data) {
              ret += encodeURIComponent(it) + "=" + encodeURIComponent(data[it]) + "&";
            }
            return ret;
          }],
        })
        .then((response) => {
          const result = response.data;
          
          if (result.code === 202) {
            // 异步处理开始
            this.handleAsyncProcessing(result);
          } else if (result.code === 200) {
            // 同步直接成功
            this.handleAuditSuccess();
          } else if (result.code === 300) {
            this.handleSessionExpired(result.message);
          } else {
            this.handleAuditError(result.message || '操作失败');
          }
        })
        .catch((error) => {
          console.error('审核操作失败:', error);
          this.handleAuditError('网络错误，请稍后重试');
        });
      },
    
      // 处理取消按钮点击
      handleCancel() {
        this.auditDialogVisible = false;
        // 重置金额修改状态
        this.enableAmountModify = false;
        this.modifiedAmount = 0;
        this.originalAmount = 0;
      },
    

    exportbtnClick() {
      let params = {
        uid: localStorage.getItem("uid"),
        token: localStorage.getItem("token"),
      };
  
      // 移除省份、城市、场站参数
      // if (this.province_value) params.province = this.province_value;
      // if (this.city_value) params.city = this.city_value;
      // if (this.station_value) params.station_id = this.station_value;
      // 移除提现类型参数
      // if (this.withdrawal_type) params.withdrawal_type = this.withdrawal_type;
      if (this.status_input) params.status = this.status_input;
      if (this.withdrawal_id_input) params.withdrawal_id = this.withdrawal_id_input;
      if (this.phone_input) params.phone_number = this.phone_input;
      
      if (this.starttime_value && this.endtime_value) {
        if (this.starttime_value > this.endtime_value) {
          this.$message.warning("结束日期时间不能小于开始日期时间");
          return;
        }
        params.start_time = this.starttime_value;
        params.end_time = this.endtime_value;
      }
  
      this.$api({
        method: "post",
        url: "/api.php/withdrawalRecord/export",
        data: params,
        transformRequest: [(data) => {
          let ret = "";
          for (let it in data) {
            ret += encodeURIComponent(it) + "=" + encodeURIComponent(data[it]) + "&";
          }
return ret;
        }],
      })
      .then((su) => {
        if (su.data.code == 1 && su.data.url) {
          this.createAndDownloadFile(su.data.url);
          this.$message.success('导出成功');
        } else {
          this.$message.warning(su.data.message || '导出失败');
        }
      })
      .catch((err) => {
        console.error("导出错误:", err);
        this.$message.error("导出失败，请稍后重试");
      });
    },
// 处理对话框关闭
handleDialogClose(done) {
  if (this.asyncProcessing) {
    this.$confirm('处理仍在进行中，关闭对话框不会中断处理，确定要关闭吗？', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    }).then(() => {
      this.auditDialogVisible = false;
      if (done && typeof done === 'function') {
        done();
      }
    }).catch(() => {
      // 用户取消关闭
    });
  } else {
    this.auditDialogVisible = false;
    if (done && typeof done === 'function') {
      done();
    }
  }
},

// 处理取消按钮点击
handleCancel() {
  this.auditDialogVisible = false;
},
    createAndDownloadFile(content) {
      let link = document.createElement("a");
      let contentArr = content.split("/");
      contentArr[0] = JSON.parse(API_ROOT.API_ROOT);
      content = contentArr[0] + "/" + contentArr[1] + "/" + contentArr[2] + "/" + contentArr[3];
      link.href = content;
      link.click();
    },

    handleSessionExpired(message) {
      localStorage.clear();
      this.$router.push("/login");
      this.$message.warning(message || "登录已过期，请重新登录");
    },
// 处理异步处理响应
    handleAsyncProcessing(responseData) {
      this.asyncProcessing = true;
      this.currentTaskId = responseData.data.task_id;
      
      // 关闭审核对话框
      this.auditDialogVisible = false;
      this.auditLoading = false;
      
      // 显示异步处理提示框
      this.$message({
        message: '系统正在处理中，请稍候...',
        type: 'info',
        duration: 0, // 持续显示
        showClose: true
      });
      
      // 开始轮询状态
      this.startStatusPolling();
    },

    // 显示异步处理状态
    showAsyncProcessingStatus(taskData) {
      // 可以在这里显示异步处理的详细信息
      console.log('异步处理开始，任务ID:', this.currentTaskId, '任务数据:', taskData);
    },

    // 开始状态轮询
    startStatusPolling() {
      this.pollingCount = 0;
      this.pollingInterval = setInterval(() => {
        this.pollTaskStatus();
      }, this.pollingDelay);
    },

    // 轮询任务状态
    async pollTaskStatus() {
      if (this.pollingCount >= this.maxPollingCount) {
        this.handlePollingTimeout();
        return;
      }

      // 添加task_id安全检查
      if (!this.currentTaskId) {
        console.error('当前任务ID为空，无法进行轮询');
        this.handlePollingTimeout();
        return;
      }

      this.pollingCount++;

      try {
        const response = await this.$api({
          method: "post",
          url: "/api.php/paymentRecord/index",
          data: {
            uid: localStorage.getItem("uid"),
            token: localStorage.getItem("token"),
            action: "check_refund_status",
            task_id: this.currentTaskId
          },
          transformRequest: [(data) => {
          let ret = "";
          for (let it in data) {
            ret += encodeURIComponent(it) + "=" + encodeURIComponent(data[it]) + "&";
          }
          return ret;
        }],
        });

        const result = response.data;
        
        if (result.code === 200) {
          // 任务完成
          this.handleTaskCompleted(result);
        } else if (result.code === 202) {
          // 任务仍在处理中，继续轮询
          this.updateProcessingStatus(result.data);
        } else {
          // 任务失败
          this.handleTaskFailed(result);
        }
      } catch (error) {
        console.error('轮询任务状态失败:', error);
        // 网络错误不影响轮询继续
      }
    },

    // 处理任务完成
    handleTaskCompleted(result) {
      this.clearPollingInterval();
      // 关闭提示框
      this.$message.closeAll();
      // 重置异步状态
      this.resetAsyncState();
      // 处理审核成功
      this.handleAuditSuccess();
      this.$message.success('处理完成');
    },

    // 处理任务失败
    handleTaskFailed(result) {
      this.clearPollingInterval();
      // 关闭提示框
      this.$message.closeAll();
      // 重置异步状态
      this.resetAsyncState();
      // 处理审核错误
      this.handleAuditError(result.message || '处理失败');
    },

    // 处理轮询超时
    handlePollingTimeout() {
      this.clearPollingInterval();
      // 关闭提示框
      this.$message.closeAll();
      // 重置异步状态
      this.resetAsyncState();
      // 处理审核错误
      this.handleAuditError('处理超时，请稍后查看结果');
    },

    // 更新处理状态
    updateProcessingStatus(taskData) {
      // 可以在这里更新处理状态信息
      console.log('处理进度更新:', taskData);
    },

    // 重置异步状态
    resetAsyncState() {
      this.asyncProcessing = false;
      this.currentTaskId = null;
      this.pollingCount = 0;
      this.clearPollingInterval();
    },

    // 清理轮询定时器
    clearPollingInterval() {
      if (this.pollingInterval) {
        clearInterval(this.pollingInterval);
        this.pollingInterval = null;
      }
    },

    // 审核成功处理
    handleAuditSuccess() {
      this.auditLoading = false;
      this.auditDialogVisible = false;
      
      // 根据审核动作显示不同的成功消息
      let successMessage = '';
      if (this.auditAction === 'approve') {
        successMessage = '审核通过成功';
      } else if (this.auditAction === 'reject') {
        successMessage = '审核拒绝成功';
      } else if (this.auditAction === 'reaudit') {
        successMessage = '再次审核成功，提现申请已重新提交';
      }
      
      this.$message.success(successMessage);
      
      // 刷新数据
      this.querybtnClick(String(this.currentPage));
      
      // 重置审核相关状态
      this.resetAuditState();
    },

    // 重置审核状态
    resetAuditState() {
      this.currentWithdrawalData = null;
      this.auditAction = '';
      this.rejectReason = '';
      this.dialogTitle = '';
    },

    // 处理审核错误
    handleAuditError(message) {
      this.auditLoading = false;
      this.$message.error(message);
    },

    // // 重置异步处理状态
    // resetAsyncState() {
    //   this.clearPollingInterval();
    //   this.asyncProcessing = false;
    //   this.currentTaskId = null;
    //   this.pollingCount = 0;
    //   this.dialogTitle = this.auditAction === 'approve' ? '审核通过' : '审核拒绝';
    // },

    // // 清除轮询定时器
    // clearPollingInterval() {
    //   if (this.pollingInterval) {
    //     clearInterval(this.pollingInterval);
    //     this.pollingInterval = null;
    //   }
    // },
    beforeDestroy() {
      this.clearPollingInterval();
      // 关闭所有提示框
      this.$message.closeAll();
    },
  }
};
</script>

<style scoped>
.withdrawal-record {
  padding: 20px;
}

.topview {
  margin-bottom: 20px;
}

.top {
  font-size: 18px;
  font-weight: bold;
  color: #333;
}

.centerview ul {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.centerview li {
  margin-bottom: 10px;
}

.bottomviewtwo {
  margin-top: 20px;
}

.cutpagesview {
  margin-top: 20px;
  text-align: center;
}

.audit-dialog-content .info-item {
  margin-bottom: 10px;
  display: flex;
}

.audit-dialog-content .label {
  width: 80px;
  color: #666;
}

.audit-dialog-content .value {
  flex: 1;
  color: #333;
}

.audit-reason {
  margin-top: 15px;
}

/* 审核按钮布局 */
.audit-buttons {
  display: flex;
  gap: 8px;
  justify-content: center;
  align-items: center;
}

.reaudit-button {
  display: flex;
  justify-content: center;
}

.audit-buttons .el-button {
  min-width: 70px;
  padding: 6px 8px;
  font-size: 12px;
  line-height: 1.2;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* 审核加载过渡画面 */
.audit-loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 20px;
  background-color: #f8f9fa;
  border-radius: 4px;
  margin-top: 15px;
}

.audit-loading .el-icon {
  font-size: 24px;
  color: #409eff;
  margin-bottom: 10px;
  animation: rotating 2s linear infinite;
}

.audit-loading .loading-text {
  font-size: 14px;
  color: #606266;
}

@keyframes rotating {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

/* 异步处理状态样式 */
.async-processing-status {
  text-align: center;
  padding: 20px 0;
}

.processing-info {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 15px;
}

.processing-icon {
  font-size: 32px;
  color: #409eff;
  margin-right: 15px;
  animation: rotating 2s linear infinite;
}

.processing-text p {
  margin: 5px 0;
  color: #606266;
}

.processing-tip {
  font-size: 12px;
  color: #909399;
}
.task-info {
  background-color: #f5f7fa;
  padding: 8px 12px;
  border-radius: 4px;
  margin-top: 10px;
}
.task-label {
  color: #909399;
  font-size: 12px;
}

.task-value {
  color: #606266;
  font-family: monospace;
  font-size: 12px;
}

/* 钱包资金余额样式 */
.fund-pool-item {
  margin-bottom: 8px;
}

.fund-pool-button {
  width: 100%;
  font-size: 14px;
  font-weight: 500;
  border-radius: 6px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);
  transition: all 0.3s ease;
  border: 1px solid #e8e8e8;
  background: linear-gradient(135deg, #f8f9fa 0%, #f0f2f5 100%);
}

.fund-pool-button:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.12);
  background: linear-gradient(135deg, #f0f2f5 0%, #e8eaed 100%);
}

.button-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
}

.button-text {
  font-size: 12px;
  color: #666;
  margin-bottom: 4px;
  font-weight: normal;
}
.balance-amount {
  font-size: 16px;
  font-weight: 600;
  color: #5a8dee;
}

.querybutton.search {
  width: 100%;
  border-radius: 6px;
  font-weight: 500;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);
  transition: all 0.3s ease;
  background: linear-gradient(135deg, #5a8dee 0%, #6d9cf0 100%);
  border: none;
}

.querybutton.search:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(90, 141, 238, 0.25);
  background: linear-gradient(135deg, #6d9cf0 0%, #7ea9f2 100%);
}

/* 钱包资金对话框样式 */
.fund-pool-dialog .el-dialog {
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
}

/* 自定义单选按钮样式 - 优化版本 */
.custom-radio-group {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.custom-radio-label {
  display: flex;
  align-items: center;
  cursor: pointer;
  position: relative;
  padding-left: 32px;
  min-height: 24px;
  font-size: 14px;
  color: #606266;
  transition: color 0.3s;
}

.custom-radio-label:hover {
  color: #409eff;
}

.custom-radio-input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  width: 0;
  height: 0;
}

.custom-radio-checkmark {
  position: absolute;
  top: 0;
  left: 0;
  height: 18px;
  width: 18px;
  background-color: #fff;
  border: 2px solid #dcdfe6;
  border-radius: 50%;
  transition: all 0.3s;
}

.custom-radio-label:hover .custom-radio-checkmark {
  border-color: #409eff;
}

.custom-radio-input:checked + .custom-radio-checkmark {
  background-color: #409eff;
  border-color: #409eff;
}

.custom-radio-input:checked + .custom-radio-checkmark::after {
  content: "";
  position: absolute;
  display: block;
  top: 50%;
  left: 50%;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: white;
  transform: translate(-50%, -50%);
}

.custom-radio-text {
  margin-left: 8px;
  line-height: 1.4;
}

/* 确保原有的样式不受影响 */
.fund-pool-dialog-content {
  padding: 0;
}

.info-section {
  margin-bottom: 20px;
  padding: 18px;
  background: #ffffff;
  border-radius: 8px;
  border-left: 4px solid #8bb2f2;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
}

.info-section:last-child {
  margin-bottom: 0;
}

.section-title {
  font-size: 15px;
  font-weight: 500;
  color: #444;
  margin: 0 0 12px 0;
  display: flex;
  align-items: center;
}

.section-title::before {
  content: "•";
  color: #8bb2f2;
  margin-right: 8px;
  font-size: 18px;
}

.radio-group {
  display: flex;
  gap: 20px;
}

.custom-radio .el-radio__label {
  font-size: 14px;
  color: #666;
}

.custom-radio .el-radio__input.is-checked + .el-radio__label {
  color: #5a8dee;
  font-weight: 500;
}

.time-section {
  background: #f8fafc;
  border-left-color: #7bc47a;
}

.time-section .section-title::before {
color: #7bc47a;
}

.time-display {
  display: flex;
  align-items: center;
  margin-bottom: 8px;
  padding: 8px 12px;
  background: #f9f9f9;
  border-radius: 4px;
  border: 1px solid #eee;
}

.time-display:last-child {
  margin-bottom: 0;
}

.time-label {
  font-size: 13px;
  color: #777;
  min-width: 70px;
  font-weight: 500;
}

.time-value {
  font-size: 13px;
  color: #444;
  font-family: 'Courier New', monospace;
  background: #f5f7fa;
  padding: 2px 6px;
  border-radius: 3px;
  flex: 1;
}

.balance-section {
  background: #f8fafc;
  border-left-color: #e6a23c;
}

.balance-section .section-title::before {
  color: #e6a23c;
}

.balance-display {
  text-align: center;
  padding: 10px 0;
}

.balance-item {
  display: inline-block;
  background: linear-gradient(135deg, #f8f9fa 0%, #f0f2f5 100%);
  padding: 15px 25px;
  border-radius: 8px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);
  border: 1px solid #e8e8e8;
}

.balance-label {
  font-size: 14px;
  color: #777;
  margin-right: 10px;
}

.balance-amount.large {
  font-size: 22px;
  font-weight: 600;
  color: #5a8dee;
  text-shadow: 0 1px 1px rgba(0, 0, 0, 0.05);
}

.dialog-footer {
  display: flex;
  justify-content: center;
  padding: 20px 30px;
  border-top: 1px solid #eee;
  background: #fafbfc;
}

.dialog-button {
  min-width: 100px;
  border-radius: 6px;
  font-weight: 500;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);
  transition: all 0.3s ease;
  background: #f0f2f5;
  border: 1px solid #ddd;
  color: #666;
}

.dialog-button:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.12);
  background: #e8eaed;
  color: #444;
}

/* 搜索表单布局 */
.search-form {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  align-items: center;
}

.search-inputs-row {
  display: flex;
  gap: 10px;
  align-items: center;
}

.input-group {
  display: flex;
  gap: 10px;
  align-items: center;
}

.action-buttons {
  display: flex;
  flex-direction: row;
  gap: 8px;
  height: 100%;
  justify-content: flex-start;
  align-items: center;
}

.action-buttons li {
  margin-bottom: 0;
  flex: 1;
}

/* 钱包资金按钮样式 */
.fund-pool-button {
  height: 40px !important;
  border-radius: 6px !important;
  border: 1px solid #dcdfe6 !important;
  background: linear-gradient(135deg, #f8f9fa 0%, #f0f2f5 100%) !important;
  color: #606266 !important;
  font-weight: 500 !important;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05) !important;
  transition: all 0.3s ease !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  padding: 0 12px !important;
}

.fund-pool-button:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1) !important;
  background: linear-gradient(135deg, #f0f2f5 0%, #e8eaed 100%) !important;
  border-color: #c0c4cc !important;
}

.button-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  line-height: 1.2;
}

.button-text {
  font-size: 12px;
  color: #606266;
  margin-bottom: 2px;
}

.balance-amount {
  font-size: 14px;
  font-weight: 600;
  color: #5a8dee;
}

/* 查询按钮样式 */
.querybutton.search {
  height: 40px !important;
  border-radius: 6px !important;
  font-weight: 500 !important;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05) !important;
  transition: all 0.3s ease !important;
}

.querybutton.search:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1) !important;
}

/* 整体布局 */
.centerview {
  padding: 20px;
  background: #ffffff;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  margin-bottom: 20px;
}

.centerview .el-row {
  align-items: center;
}

/* 调整搜索表单间距 */
.search-form li {
  margin-bottom: 0;
}

/* 确保按钮区域与其他表单元素对齐 */
.action-buttons {
  padding-top: 0;
}

/* 响应式布局 */
@media (max-width: 1200px) {
  .action-buttons {
    flex-direction: column;
  }
  
  .action-buttons li {
    flex: none;
  }
}

/* 搜索表单整体布局 */
.search-form {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  align-items: center;
  padding: 0;
  margin: 0;
}

.search-form li {
  margin: 0;
  padding: 0;
}

/* 输入框和选择器的间距 */
.search-form .el-input,
.search-form .el-select,
.search-form .el-date-picker {
  margin: 0;
}

/* 按钮区域与其他表单的对齐 */
.centerview .el-col:last-child {
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

/* 钱包资金按钮内容显示 */
.fund-pool-button .button-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
}

/* 按钮在横向布局中的显示 */
.action-buttons {
  min-height: 40px;
}

/* 确保按钮在不同屏幕尺寸下的显示效果 */
@media (max-width: 768px) {
  .action-buttons {
    flex-direction: column;
    gap: 10px;
  }
  
  .action-buttons li {
    width: 100%;
  }
}

/* 自定义复选框样式 */
.custom-checkbox-wrapper {
  display: inline-flex;
  align-items: center;
  margin-right: 10px;
}

.custom-checkbox {
  position: absolute;
  opacity: 0;
  width: 0;
  height: 0;
}

.custom-checkbox-label {
  display: flex;
  align-items: center;
  cursor: pointer;
  font-size: 14px;
  color: #606266;
  user-select: none;
}

.custom-checkbox-icon {
  display: inline-block;
  width: 14px;
  height: 14px;
  border: 1px solid #dcdfe6;
  border-radius: 2px;
  margin-right: 8px;
  position: relative;
  transition: all 0.2s;
  background-color: #fff;
}

.custom-checkbox:checked + .custom-checkbox-label .custom-checkbox-icon {
  background-color: #409eff;
  border-color: #409eff;
}

.custom-checkbox:checked + .custom-checkbox-label .custom-checkbox-icon::after {
  content: '';
  position: absolute;
  left: 4px;
  top: 1px;
  width: 4px;
  height: 8px;
  border: solid white;
  border-width: 0 2px 2px 0;
  transform: rotate(45deg);
}

.custom-checkbox:focus + .custom-checkbox-label .custom-checkbox-icon {
  border-color: #409eff;
  box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.2);
}

/* 金额修改区域样式 */
.amount-modify-section {
  margin: 15px 0;
  padding: 15px;
  background: linear-gradient(145deg, #f8fafc 0%, #f1f5f9 100%);
  border-radius: 8px;
  border: 1px solid #e2e8f0;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
}

.section-title {
  font-weight: 600;
  margin-bottom: 12px;
  color: #1e293b;
  font-size: 14px;
  letter-spacing: 0.2px;
}

.amount-input-group {
  margin-bottom: 12px;
  position: relative;
}

/* 优雅的禁用状态样式 */
.amount-input-group .el-input-number.is-disabled {
  position: relative;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.amount-input-group .el-input-number.is-disabled::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(135deg, rgba(255, 255, 255, 0.9) 0%, rgba(248, 250, 252, 0.9) 100%);
  border-radius: 6px;
  z-index: 1;
  pointer-events: none;
}

.amount-input-group .el-input-number.is-disabled .el-input__inner {
  background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
  border: 1.5px solid #e2e8f0;
  border-radius: 6px;
  color: #94a3b8;
  font-weight: 500;
  cursor: not-allowed;
  box-shadow: inset 0 2px 4px rgba(0, 0, 0, 0.02);
  transition: all 0.3s ease;
  position: relative;
  z-index: 2;
}

.amount-input-group .el-input-number.is-disabled .el-input__inner:hover {
  border-color: #e2e8f0;
  box-shadow: inset 0 2px 4px rgba(0, 0, 0, 0.02);
}

/* 禁用状态下的占位符样式 */
.amount-input-group .el-input-number.is-disabled .el-input__inner::placeholder {
  color: #cbd5e1;
  font-style: italic;
}

/* 禁用状态下的增减按钮样式 */
.amount-input-group .el-input-number.is-disabled .el-input-number__decrease,
.amount-input-group .el-input-number.is-disabled .el-input-number__increase {
  background: linear-gradient(135deg, #f1f5f9 0%, #e2e8f0 100%);
  border-color: #e2e8f0;
  color: #94a3b8;
  cursor: not-allowed;
}

.amount-input-group .el-input-number.is-disabled .el-input-number__decrease:hover,
.amount-input-group .el-input-number.is-disabled .el-input-number__increase:hover {
  background: linear-gradient(135deg, #f1f5f9 0%, #e2e8f0 100%);
  border-color: #e2e8f0;
  color: #94a3b8;
}

/* 启用状态下的输入框样式（作为对比） */
.amount-input-group .el-input-number:not(.is-disabled) .el-input__inner {
  background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);
  border: 1.5px solid #e2e8f0;
  border-radius: 6px;
  color: #1e293b;
  transition: all 0.3s ease;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
}

.amount-input-group .el-input-number:not(.is-disabled) .el-input__inner:focus {
  border-color: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
  outline: none;
}

.amount-input-group .el-input-number:not(.is-disabled) .el-input__inner:hover {
  border-color: #94a3b8;
}

/* 启用状态下的增减按钮样式 */
.amount-input-group .el-input-number:not(.is-disabled) .el-input-number__decrease,
.amount-input-group .el-input-number:not(.is-disabled) .el-input-number__increase {
  background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
  border-color: #e2e8f0;
  color: #64748b;
  transition: all 0.2s ease;
}

.amount-input-group .el-input-number:not(.is-disabled) .el-input-number__decrease:hover,
.amount-input-group .el-input-number:not(.is-disabled) .el-input-number__increase:hover {
  background: linear-gradient(135deg, #3b82f6 0%, #2563eb 100%);
  border-color: #3b82f6;
  color: white;
}

/* 金额操作区域 */
.amount-actions {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 12px;
  padding: 8px 0;
}

/* 自定义复选框样式优化 */
.custom-checkbox-wrapper {
  display: inline-flex;
  align-items: center;
  margin-right: 12px;
}

.custom-checkbox-label {
  display: flex;
  align-items: center;
  cursor: pointer;
  font-size: 14px;
  color: #475569;
  font-weight: 500;
  user-select: none;
  transition: color 0.2s ease;
}

.custom-checkbox-label:hover {
  color: #334155;
}

.custom-checkbox-icon {
  display: inline-block;
  width: 16px;
  height: 16px;
  border: 2px solid #cbd5e1;
  border-radius: 4px;
  margin-right: 8px;
  position: relative;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);
}

.custom-checkbox:checked + .custom-checkbox-label .custom-checkbox-icon {
  background: linear-gradient(135deg, #10b981 0%, #059669 100%);
  border-color: #10b981;
  box-shadow: 0 2px 4px rgba(16, 185, 129, 0.2);
}

.custom-checkbox:checked + .custom-checkbox-label .custom-checkbox-icon::after {
  content: '';
  position: absolute;
  left: 4px;
  top: 1px;
  width: 5px;
  height: 9px;
  border: solid white;
  border-width: 0 2px 2px 0;
  transform: rotate(45deg);
}

.custom-checkbox:focus + .custom-checkbox-label .custom-checkbox-icon {
  border-color: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}

/* 重置按钮样式优化 */
.reset-button {
  color: #3b82f6;
  font-weight: 500;
  transition: all 0.2s ease;
  padding: 4px 8px;
  border-radius: 4px;
}

.reset-button:hover:not(.is-disabled) {
  color: #2563eb;
  background-color: rgba(59, 130, 246, 0.1);
}

.reset-button.is-disabled {
  color: #94a3b8;
  cursor: not-allowed;
}

/* 金额差异显示 */
.amount-difference {
  margin-top: 10px;
  padding: 8px 12px;
  background: linear-gradient(135deg, #f0f9ff 0%, #e0f2fe 100%);
  border-radius: 6px;
  border-left: 3px solid #0ea5e9;
}

.difference-label {
  color: #475569;
  font-weight: 500;
}

.difference-value {
  font-weight: 600;
  margin-left: 4px;
}

.difference-value.positive {
  color: #10b981;
}

.difference-value.negative {
  color: #ef4444;
}

/* 审核信息样式 */
.audit-info .info-item {
  margin-bottom: 8px;
  display: flex;
}

.audit-info .label {
  color: #606266;
  font-weight: 500;
  min-width: 80px;
}

.audit-info .value {
  color: #303133;
}

</style>